import { createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { seamlessImmutableReconciler } from 'redux-persist-seamless-immutable';


const getInformationToPersist = (state, key) => {
  switch (key) {
    case 'authentication':
    case 'app':
      return state;
    default:
      return null;
  }
};

const customTransform = createTransform(getInformationToPersist, getInformationToPersist);

// return a redux-persist config
export default {
  key: 'root',
  stateReconciler: seamlessImmutableReconciler,
  transforms: [customTransform],
  whitelist: ['authentication', 'app'],
  storage,
};
